// engagementService events
import createEngagementServiceEvent from '../../../../engagementService/events/create.event.engagementService';

const openCreateEngagementServiceHandler = () => () =>
  createEngagementServiceEvent.publish();

export default openCreateEngagementServiceHandler;
